var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row bottom-widgets" }, [
    _c(
      "div",
      { staticClass: "flex md6 xs12" },
      [
        _c(
          "vuestic-widget",
          { staticClass: "no-h-padding no-v-padding" },
          [_c("vuestic-feed", { attrs: { initialPosts: _vm.posts } })],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex md6 xs12" },
      [
        _c(
          "vuestic-widget",
          { staticClass: "business-posts" },
          [
            _c("vuestic-social-news", {
              staticClass: "vuestic-social-news",
              attrs: { news: _vm.news, url: "http://instagram.com/smartapant" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }